import React, { useState, useEffect } from 'react';
import { Modal, Button, Dropdown } from 'react-bootstrap';
import { NavLink, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import Brand from '../../../../assets/images/logo.png';
import { useRef } from 'react';
import { ref, update, onChildAdded, onChildChanged } from "firebase/database";
import { validateAndSortNumbers } from "../../../../utils/functions";
import firebaseDb from '../../../../utils/firebase.util';
import { TIME_ZONE } from '../../../../config/variables';
import moment from 'moment-timezone';

function InterpreterSideBarCtrl(props){

    const user = props.user;
    const [chatUnread, setChatUnread] = useState(0)

    var chatUnreadRef = useRef(0)
    const chatInitializeRef = useRef(false)
    var usersList = {}
    var keysArr = []


    let underscorePattern = /[_]/i
    let filteredRole = user.role
    if (underscorePattern.test(filteredRole)) {

        let splitStringToArr = filteredRole.split('_')
        filteredRole = ''
        for (let arrElm of splitStringToArr) {
            filteredRole = filteredRole + ' ' + arrElm
        }
    }

    useEffect(() => {

        if (chatInitializeRef.current === false) {
            initiateChats()
        }

    }, [chatUnread]);

    const initiateChats = async () => {

        if (Object.keys(user).length > 0) {

            const chatListRef = ref(firebaseDb, `chats`);

            chatInitializeRef.current = true

            onChildAdded(chatListRef, (data) => {

                var otherUser = null

                let value = data.val()

                let recentCount = chatUnreadRef.current
                for (let itemKey in value) {

                    let usrItem = value[itemKey]

                    // if(usrItem?.to_user_unique_id === user?.unique_id){
                    //     if(usrItem?.is_seen == 0){
                    //         recentCount = recentCount + 1 
                    //     }
                    // }

                    // if(usrItem.role != 'super_admin' && usrItem.role != 'sub_super_admin') {

                    otherUser = usrItem
                    let keyName = `${usrItem.unique_id}`

                    if (!usersList.hasOwnProperty(keyName)) {
                        usersList[keyName] = []
                    }

                    if (usrItem['to_user_unique_id'] == user?.unique_id && usrItem['is_seen'] === 0 && !keysArr.includes(itemKey)) {
                        recentCount = recentCount + 1
                    }

                    if (!keysArr.includes(itemKey)) {
                        keysArr.push(itemKey)
                        usersList[keyName].push(usrItem)
                    }

                    // }

                }

                /* Update status to Online, Offline */

                for (let itmKey in value) {

                    let usrItm = value[itmKey]

                    if (otherUser) {
                        if (usrItm.role == user.role && usrItm.user_id == user.id) {
                            const updates = {};
                            updates[`chats/user_${validateAndSortNumbers(otherUser.unique_id, user.unique_id)}`] = {
                                ...value[itmKey],
                                status: 'online',
                                timestamp: moment().tz(TIME_ZONE).format('XX'),
                                timestampFormatted: moment().tz(TIME_ZONE).format('YYYY-MM-DD HH:mm:ss')
                            };

                            update(ref(firebaseDb), updates);
                        }
                    }
                }
                chatUnreadRef.current = recentCount
                setChatUnread(chatUnreadRef.current)
            });

            onChildChanged(chatListRef, (data) => {

                let value = data.val()

                let recentCount = chatUnreadRef.current


                for (let key in value) {
                    let usrItem = value[key]

                    // if(usrItem.role != 'super_admin' && usrItem.role != 'sub_super_admin') {

                    let keyName = `${usrItem.unique_id}`
                    if (!usersList.hasOwnProperty(keyName)) {
                        usersList[keyName] = []
                    }

                    if (usrItem['to_user_unique_id'] == user?.unique_id && usrItem['is_seen'] === 0 && !keysArr.includes(key)) {
                        recentCount = recentCount + 1
                    }

                    if (!keysArr.includes(key)) {
                        keysArr.push(key)
                        usersList[keyName].push(usrItem)
                        /* if( usrItem['is_seen'] === 0 ) {

                            chatUnreadRef.current = chatUnreadRef.current + 1
 
                        }else {
 
                            chatUnreadRef.current = Math.abs(chatUnreadRef.current - 1)
                        } */
                    }

                    // }
                }
                chatUnreadRef.current = recentCount

                setChatUnread(chatUnreadRef.current)

            });
        }
    }

    const navigate = useNavigate()

    const [ alertModalShow, setAlertModalShow ] = useState(false)

    const openChat = (e) => {
        e.preventDefault()

        if(user.is_chat_blocked) {
            setAlertModalShow(true)
        }else {
            navigate('/interpreter/chat')
        }
    }

    

    return(
        <>
        <NavLink className='logged_user'>
            {/* <img className='logged_user_img' src={user.picture_path} />
            <p>{user.full_name}</p>
            <span className='logged_user_typ'>{user.role}</span> */}
            
            <img width={100} src={Brand} />
        </NavLink>
        <Button className="toggle" onClick={props.toggleSideBar}>
            <span className="line-toggle"></span>
            <span className="line-toggle"></span>
            <span className="line-toggle"></span>
        </Button>
        <div className='sidebar_menu'>
            <NavLink to="dashboard">
                <div className='d-flex align-items-center'>
                    <span className="menu_icon">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path className="path_fill" fillRule="evenodd" clipRule="evenodd" d="M7 3C9.20914 3 11 4.79086 11 7C11 9.20914 9.20914 11 7 11C4.79086 11 3 9.20914 3 7C3 4.79086 4.79086 3 7 3ZM7 5C5.89543 5 5 5.89543 5 7C5 8.10457 5.89543 9 7 9C8.10457 9 9 8.10457 9 7C9 5.89543 8.10457 5 7 5ZM17 3C19.2091 3 21 4.79086 21 7C21 9.20914 19.2091 11 17 11C14.7909 11 13 9.20914 13 7C13 4.79086 14.7909 3 17 3ZM17 5C15.8954 5 15 5.89543 15 7C15 8.10457 15.8954 9 17 9C18.1046 9 19 8.10457 19 7C19 5.89543 18.1046 5 17 5ZM11 17C11 14.7909 9.20914 13 7 13C4.79086 13 3 14.7909 3 17C3 19.2091 4.79086 21 7 21C9.20914 21 11 19.2091 11 17ZM5 17C5 15.8954 5.89543 15 7 15C8.10457 15 9 15.8954 9 17C9 18.1046 8.10457 19 7 19C5.89543 19 5 18.1046 5 17ZM17 13C19.2091 13 21 14.7909 21 17C21 19.2091 19.2091 21 17 21C14.7909 21 13 19.2091 13 17C13 14.7909 14.7909 13 17 13ZM17 15C15.8954 15 15 15.8954 15 17C15 18.1046 15.8954 19 17 19C18.1046 19 19 18.1046 19 17C19 15.8954 18.1046 15 17 15Z" fill=""/>
                        </svg>
                    </span>
                    <span className="">Dashboard</span>
                </div>
            </NavLink>
            <NavLink to="assignments">
                <div className='d-flex align-items-center'>
                    <span className="menu_icon">
                        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path className="path_fill" fill-rule="evenodd" clip-rule="evenodd" d="M8.69049 0.571907C6.48275 0.920086 4.56146 1.91955 2.93618 3.56515C1.91571 4.59829 1.18459 5.69424 0.692451 6.9283C0.131251 8.33532 0 9.06685 0 10.7858C0 12.5048 0.131251 13.2363 0.692451 14.6433C1.6561 17.0599 3.78888 19.2472 6.17148 20.2625C7.71986 20.9224 9.52805 21.2143 11.1335 21.0636L11.9405 20.9879L11.9782 19.2425L12.0159 17.4969L12.4204 16.6775C12.8384 15.8306 13.5842 15.0292 14.214 14.75C14.4548 14.6433 14.5541 14.5003 14.6487 14.1239C14.8357 13.3793 15.3767 12.4474 15.9052 11.9595C17.0812 10.874 18.9266 10.5058 20.3842 11.0659C20.5798 11.1412 20.5858 11.0986 20.5168 10.1168C20.3359 7.53839 19.336 5.34531 17.5062 3.51277C16.1277 2.13231 14.6011 1.25557 12.7297 0.770036C11.7753 0.52232 9.66199 0.41863 8.69049 0.571907ZM14.9968 7.55722C15.3494 7.83505 15.4452 8.23529 15.2482 8.60864C15.1627 8.77074 13.7942 10.1982 12.2071 11.7808C9.5578 14.4225 9.29143 14.658 8.95385 14.658C8.62175 14.658 8.41639 14.4881 6.83719 12.9065C5.29171 11.3589 5.08818 11.1142 5.08818 10.8042C5.08818 10.3366 5.49611 9.92531 5.95978 9.92531C6.25612 9.92531 6.48941 10.1086 7.63189 11.2397L8.95955 12.5542L11.5081 10.0146C12.9098 8.61778 14.1291 7.44933 14.2178 7.41792C14.5254 7.30886 14.7273 7.345 14.9968 7.55722ZM18.1912 12.601C17.6445 12.7802 17.2373 13.05 16.8772 13.4712C16.4359 13.9876 16.2585 14.5241 16.2585 15.3428C16.2585 15.8319 16.2246 15.9488 16.083 15.9488C15.5805 15.9488 14.9851 16.2485 14.4713 16.7598C13.7258 17.5019 13.6506 17.8728 13.6978 20.574C13.738 22.8769 13.8115 23.1729 14.5032 23.8155C15.2385 24.4985 15.2482 24.5 18.8362 24.5C22.0129 24.5 22.1257 24.4928 22.5571 24.2616C23.1198 23.9603 23.7057 23.2799 23.8671 22.7405C24.0673 22.0715 24.0328 18.2589 23.821 17.6364C23.5397 16.8095 22.4015 15.9488 21.5895 15.9488C21.4478 15.9488 21.414 15.8319 21.414 15.3428C21.414 15.0095 21.3579 14.5493 21.2893 14.3201C21.1274 13.7791 20.5375 13.0951 19.9925 12.8166C19.5152 12.5727 18.6083 12.4642 18.1912 12.601ZM19.4318 14.4919C19.6483 14.7086 19.6955 14.8624 19.6955 15.3524V15.9488H18.8362H17.977V15.3524C17.977 14.6346 18.2878 14.2278 18.8362 14.2278C19.0455 14.2278 19.2657 14.3254 19.4318 14.4919ZM19.4318 19.6549C19.9647 20.1884 19.5871 21.1118 18.8362 21.1118C18.627 21.1118 18.4068 21.0142 18.2407 20.8477C18.0744 20.6813 17.977 20.4608 17.977 20.2513C17.977 20.0418 18.0744 19.8213 18.2407 19.6549C18.4068 19.4883 18.627 19.3908 18.8362 19.3908C19.0455 19.3908 19.2657 19.4883 19.4318 19.6549Z" fill="white"/>
                        </svg>
                    </span>
                    <span className="">Assignments</span>
                </div>
            </NavLink>
            
            {/* <NavLink to="payments">
                <div className='d-flex align-items-center'>
                    <span className="menu_icon">
                        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect className="path_fill" x="4" y="5" width="16" height="6" rx="1" fill=""/>
                            <path className="path_stroke" d="M23.75 11.25C25.1313 11.25 26.25 12.3687 26.25 13.75V22.5C26.25 23.8813 25.1313 25 23.75 25H11.25C9.86875 25 8.75 23.8813 8.75 22.5V22.5" stroke="" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            <path className="path_stroke" d="M18.75 21.25L21.25 18.75L18.75 16.25" stroke="" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            <path  className="path_stroke" d="M3.75 11.25H20V7.5C20 6.11875 18.8813 5 17.5 5H6.25C4.86875 5 3.75 6.11875 3.75 7.5V16.25C3.75 17.6313 4.86875 18.75 6.25 18.75H21.25" stroke="" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>


                    </span>
                    <span className="">Payments</span>
                </div>
            </NavLink> */}
            <NavLink to="salary">
                <div className='d-flex align-items-center'>
                    <span className="menu_icon">
                        <svg width="30" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path className="path_stroke" fill-rule="evenodd" clip-rule="evenodd" d="M7.5 26.75H5C4.31 26.75 3.75 26.19 3.75 25.5V18C3.75 17.31 4.31 16.75 5 16.75H7.5C8.19 16.75 8.75 17.31 8.75 18V25.5C8.75 26.19 8.19 26.75 7.5 26.75Z" stroke="" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path className="path_stroke" d="M16.25 21.75H19.1663C19.7075 21.75 20.2337 21.575 20.6662 21.25L23.6863 18.985C24.44 18.42 25.495 18.495 26.1612 19.1612V19.1612C26.9012 19.9012 26.9012 21.1 26.1612 21.8387L23.57 24.43C22.8725 25.1275 21.9825 25.6037 21.015 25.7975L17.3525 26.53C16.6262 26.675 15.8775 26.6575 15.1587 26.4775L11.8462 25.65C11.45 25.55 11.0438 25.5 10.635 25.5H8.75" stroke="" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path className="path_stroke" d="M16.25 21.75H18.1063C19.1525 21.75 20 20.9025 20 19.8562V19.4775C20 18.6087 19.4088 17.8512 18.5663 17.6412L15.7012 16.925C15.235 16.8087 14.7575 16.75 14.2775 16.75V16.75C13.1187 16.75 11.985 17.0925 11.0213 17.7362L8.75 19.25" stroke="" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path className="path_full" fill-rule="evenodd" clip-rule="evenodd" d="M21.461 6.94404C22.8464 8.32942 22.8464 10.5756 21.461 11.961C20.0756 13.3463 17.8295 13.3463 16.4441 11.961C15.0587 10.5756 15.0587 8.32942 16.4441 6.94404C17.8295 5.55865 20.0756 5.55865 21.461 6.94404Z" fill=""/>
                            <path className="path_stroke" d="M21.461 6.94404C22.8464 8.32942 22.8464 10.5756 21.461 11.961C20.0756 13.3463 17.8295 13.3463 16.4441 11.961C15.0587 10.5756 15.0587 8.32942 16.4441 6.94404C17.8295 5.55865 20.0756 5.55865 21.461 6.94404" stroke="" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <g opacity="0.4">
                                <path className="path_fill" fill-rule="evenodd" clip-rule="evenodd" d="M18.2888 5.96875C18.1725 5.2625 17.85 4.58375 17.305 4.03875C15.92 2.65375 13.6738 2.65375 12.2888 4.03875C10.9038 5.42375 10.9038 7.67 12.2888 9.055C13.1513 9.9175 14.3463 10.2413 15.46 10.03" fill="white"/>
                                <path className="path_stroke" d="M18.2888 5.96875C18.1725 5.2625 17.85 4.58375 17.305 4.03875C15.92 2.65375 13.6738 2.65375 12.2888 4.03875C10.9037 5.42375 10.9037 7.67 12.2888 9.055C13.1513 9.9175 14.3462 10.2413 15.46 10.03" stroke="" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </g>
                        </svg>
                    </span>
                    <span className="">Salary</span>
                </div>
            </NavLink> 
            
            <NavLink to="support">
                <div className='d-flex align-items-center'>
                    <span className="menu_icon">
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path className="path_stroke path_fill" fillRule="evenodd" clipRule="evenodd" d="M7.87138 16.3125C7.88452 14.5891 9.28996 13.2013 11.0134 13.21C12.7369 13.2188 14.1283 14.6207 14.1239 16.3442C14.1196 18.0677 12.7212 19.4626 10.9977 19.4626C10.1651 19.4606 9.36743 19.1273 8.78088 18.5363C8.19433 17.9453 7.8671 17.1452 7.87138 16.3125Z" fill="" stroke="" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            <path className="path_stroke" d="M18.5017 13.1862C18.3751 13.1855 18.2606 13.2612 18.2117 13.378C18.1627 13.4948 18.1891 13.6295 18.2784 13.7193C18.3676 13.809 18.5022 13.8361 18.6193 13.7878C18.7363 13.7395 18.8126 13.6254 18.8126 13.4988C18.8133 13.416 18.7808 13.3363 18.7224 13.2776C18.664 13.2189 18.5845 13.186 18.5017 13.1862" stroke="" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            <path className="path_stroke" d="M22.3921 13.1862C22.2655 13.1855 22.151 13.2612 22.102 13.378C22.0531 13.4948 22.0795 13.6295 22.1687 13.7193C22.258 13.809 22.3926 13.8361 22.5096 13.7878C22.6267 13.7395 22.703 13.6254 22.703 13.4988C22.7037 13.416 22.6712 13.3363 22.6128 13.2776C22.5543 13.2189 22.4749 13.186 22.3921 13.1862" stroke="" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            <path className="path_stroke path_fill" fillRule="evenodd" clipRule="evenodd" d="M4.74512 26.4731V25.6915C4.75017 23.967 6.14691 22.5702 7.87142 22.5652H14.124C15.8485 22.5702 17.2453 23.967 17.2503 25.6915V26.4731C17.2491 26.9042 16.8999 27.2534 16.4688 27.2546H5.52669C5.09556 27.2534 4.74638 26.9042 4.74512 26.4731Z" fill="" stroke="" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            <path className="path_stroke" d="M11.344 8.49677C13.5403 5.35308 17.5288 4.00754 21.1807 5.17834C24.8325 6.34914 27.2951 9.76298 27.2541 13.5977C27.2131 17.4324 24.6781 20.7928 21.002 21.8852" stroke="" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </span>
                    <span className="">Support</span>
                </div>
            </NavLink>

            <NavLink to="chat"  onClick={(event) => openChat(event)}>
                <div className='d-flex align-items-center'>
                    <span className="menu_icon">
                        <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path className="path_fill" fillRule="evenodd" clipRule="evenodd" d="M10.0282 0C4.50537 0 0.0282136 4.47715 0.0282136 10C0.0194714 12.3091 0.819006 14.5485 2.28821 16.33L0.288214 18.33C0.00446904 18.6176 -0.0783831 19.0476 0.0782136 19.42C0.248082 19.788 0.62327 20.017 1.02821 20H10.0282C15.5511 20 20.0282 15.5228 20.0282 10C20.0282 4.47715 15.5511 8.22968e-08 10.0282 0ZM10.0282 18H3.43821L4.36821 17.07C4.75594 16.68 4.75594 16.05 4.36821 15.66C1.6681 12.9629 1.2491 8.73406 3.36744 5.55952C5.48578 2.38498 9.55154 1.1488 13.0784 2.60691C16.6053 4.06503 18.6112 7.81138 17.8693 11.555C17.1275 15.2986 13.8446 17.997 10.0282 18Z" fill=""/>
                        </svg>
                    </span>
                    <span className="">Chat</span>
                </div>
                {chatUnread > 0 &&
                        <span className='badge'>{chatUnread}</span>
                    }
            </NavLink>

            <NavLink to="logout">
                <div className='d-flex align-items-center'>
                    <span className="menu_icon">
                        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path className="path_fill" fillRule="evenodd" clipRule="evenodd" d="M13.5303 7.96975C13.2374 7.67686 12.7626 7.67686 12.4697 7.96975C12.1768 8.26264 12.1768 8.73752 12.4697 9.03041L15.1893 11.7501L3 11.7501C2.58579 11.7501 2.25 12.0859 2.25 12.5001C2.25 12.9143 2.58579 13.2501 3 13.2501L15.1893 13.2501L12.4697 15.9698C12.1768 16.2626 12.1768 16.7375 12.4697 17.0304C12.7626 17.3233 13.2374 17.3233 13.5303 17.0304L17.5303 13.0304C17.8232 12.7375 17.8232 12.2626 17.5303 11.9698L13.5303 7.96975ZM16.2001 3.25C17.0525 3.25 17.6468 3.25058 18.1094 3.28838C18.5633 3.32547 18.824 3.3946 19.0216 3.49523C19.4449 3.71095 19.7891 4.05516 20.0048 4.47852C20.1055 4.67604 20.1746 4.9368 20.2117 5.39068C20.2495 5.85331 20.2501 6.44755 20.2501 7.3L20.2501 17.7C20.2501 18.5525 20.2495 19.1467 20.2117 19.6093C20.1746 20.0632 20.1055 20.324 20.0049 20.5215C19.7891 20.9448 19.4449 21.289 19.0216 21.5048C18.824 21.6054 18.5633 21.6745 18.1094 21.7116C17.6468 21.7494 17.0525 21.75 16.2001 21.75L11.8001 21.75C10.9476 21.75 10.3534 21.7494 9.89077 21.7116C9.43689 21.6745 9.17612 21.6054 8.97861 21.5048C8.55524 21.289 8.21104 20.9448 7.99532 20.5215C7.89468 20.324 7.82555 20.0632 7.78847 19.6093C7.75067 19.1467 7.75009 18.5525 7.75009 17.7L7.75009 16.5C7.75009 16.0858 7.4143 15.75 7.00009 15.75C6.58587 15.75 6.25009 16.0858 6.25009 16.5L6.25009 17.7L6.25009 17.7321L6.25009 17.7321C6.25008 18.545 6.25007 19.2006 6.29345 19.7315C6.33811 20.2781 6.43247 20.7582 6.65881 21.2025C7.01834 21.9081 7.59201 22.4817 8.29762 22.8413C8.74184 23.0676 9.22198 23.162 9.76862 23.2066C10.2995 23.25 10.9551 23.25 11.768 23.25L11.8001 23.25L16.2001 23.25L16.2322 23.25C17.045 23.25 17.7006 23.25 18.2316 23.2066C18.7782 23.162 19.2583 23.0676 19.7025 22.8413C20.4082 22.4817 20.9818 21.9081 21.3414 21.2025C21.5677 20.7582 21.6621 20.2781 21.7067 19.7315C21.7501 19.2006 21.7501 18.5449 21.7501 17.7321L21.7501 17.7L21.7501 7.3L21.7501 7.26788C21.7501 6.45505 21.7501 5.79944 21.7067 5.26853C21.6621 4.72189 21.5677 4.24175 21.3414 3.79754C20.9818 3.09193 20.4082 2.51825 19.7025 2.15872C19.2583 1.93239 18.7782 1.83803 18.2316 1.79336C17.7006 1.74999 17.045 1.74999 16.2322 1.75L16.2001 1.75L11.8001 1.75L11.768 1.75C10.9551 1.74999 10.2995 1.74999 9.76862 1.79336C9.22198 1.83803 8.74184 1.93239 8.29762 2.15873C7.59201 2.51825 7.01834 3.09193 6.65881 3.79754C6.43247 4.24175 6.33811 4.7219 6.29345 5.26853C6.25007 5.79944 6.25008 6.45506 6.25009 7.2679L6.25009 7.3L6.25009 8.5C6.25009 8.91421 6.58587 9.25 7.00008 9.25C7.4143 9.25 7.75009 8.91421 7.75009 8.5L7.75009 7.3C7.75009 6.44755 7.75067 5.85331 7.78847 5.39068C7.82555 4.93681 7.89468 4.67604 7.99532 4.47852C8.21104 4.05516 8.55524 3.71095 8.97861 3.49524C9.17612 3.3946 9.43689 3.32547 9.89076 3.28838C10.3534 3.25058 10.9476 3.25 11.8001 3.25L16.2001 3.25Z" fill=""/>
                        </svg>
                    </span>
                    <span className="">Logout</span>
                </div>
            </NavLink>

            <Modal className="approve-modal" show={alertModalShow} onHide={() => setAlertModalShow(false)} backdrop="static" keyboard={false} centered>
                    <Modal.Header className='justify-content-center'>
                    </Modal.Header>
                    <Modal.Body className='text-center'>
                        <h4>You do not have access to this feature. Contact your administration for further information.</h4>
                    </Modal.Body>
                    <Modal.Footer className='justify-content-center'>
                        <div className="d-flex gap-3">
                            <Button variant="primary" onClick={() => setAlertModalShow(false)} >Ok</Button>
                        </div>
                    </Modal.Footer>
                </Modal>
            
        </div>
        </>
    )
}

const mapStateToProps = state => {
    return {
        user: state.authenticate,
        chat: state.chat
    }
}

export default connect(mapStateToProps, null)(InterpreterSideBarCtrl);